/**
 * Per-app landing-URL wiring. The role→URL mapping itself lives in
 * @vollgas/shared/auth (was duplicated per-app; hoisted per the
 * monorepo's reusable-first rule) — this file only supplies the env
 * values Vite bakes into THIS app's build.
 *
 * Used by the technical AuthGuard to kick a user with a non-staff
 * role back to their home app. ADMIN + MANAGER + TECHNICIAN are
 * allowed in technical; CUSTOMER and unknown roles are redirected.
 */
import { createLandingFor } from '@vollgas/shared/auth'

export const landingFor = createLandingFor({
  isDev: import.meta.env.DEV,
  envBase: {
    admin: import.meta.env.VITE_URL_ADMIN,
    management: import.meta.env.VITE_URL_MANAGEMENT,
    technical: import.meta.env.VITE_URL_TECHNICAL,
    web: import.meta.env.VITE_URL_WEB,
  },
})

/** Roles allowed to view the technical app. */
export const TECHNICAL_ALLOWED: ReadonlySet<string> = new Set([
  'ADMIN',
  'MANAGER',
  'TECHNICIAN',
])
